import { useGetFeatureFlagsQuery } from '@hooks/featureFlags';
import { FeatureFlag } from '@utils/constants';
import { createContext, useContext } from 'react';

interface IFeatureFlagsContext {
  isSelectedCartOn: boolean;
}

const FeatureFlagsContext = createContext<IFeatureFlagsContext>({
  isSelectedCartOn: false,
});

const FeatureFlagsProvider = (props: { children: React.ReactNode }) => {
  const { children } = props;

  const { data } = useGetFeatureFlagsQuery({
    variables: {
      keyNames: [FeatureFlag.SelectedCart],
    },
  });

  const selectedCartFlag = data?.featureFlags?.find(flag => flag.keyName === FeatureFlag.SelectedCart);

  const value = {
    isSelectedCartOn: selectedCartFlag?.keyValue === 'on',
  };

  return <FeatureFlagsContext.Provider value={value}>{children}</FeatureFlagsContext.Provider>;
};

export const useFeatureFlags = () => {
  const context = useContext(FeatureFlagsContext);

  if (!context) {
    throw new Error('useFeatureFlags must be used within FeatureFlagsProvider');
  }

  return context;
};

export default FeatureFlagsProvider;
